import React from 'react'
import { connect } from 'react-redux'

import { setPageTitle } from 'actions/pageStateActions'
import { getEntity as ge } from 'selectors/entitySelectors'
import { getYMMT as gymmt } from 'selectors/inventorySelectors'
import { getRooftopName } from 'selectors/appStatusSelectors'

import {
  getActiveQuery,
  getActiveParams,
  getActiveRouteName,
} from 'selectors/pageStateSelectors'

export const TITLES = {
  '/:dealerId/inventory': ({ getYMMT, activeQuery, rooftopName }) =>
    activeQuery.vehicleId
      ? `Your ${getYMMT(activeQuery.vehicleId)} quote from ${rooftopName}`
      : `${rooftopName} Vehicle Payments`,
  '/:dealerId/vehicle/:id': ({ getYMMT, activeParams, rooftopName }) =>
    activeParams.id
      ? `Your ${getYMMT(activeParams.id)} quote from ${rooftopName}`
      : `${rooftopName} Vehicle Payments`,
  '/:dealerId/settings/quote': ({ rooftopName }) =>
    `Quote Configuration for ${rooftopName}`,
}

export const defaultTitle = props => props.rooftopName

export class PageTitle extends React.Component {
  setPageTitle() {
    let { setPageTitle } = this.props

    setPageTitle(this.props.title)
  }

  componentDidMount() {
    this.setPageTitle()
  }

  componentDidUpdate() {
    this.setPageTitle()
  }

  render() {
    return null
  }
}

function mapStateToProps(state, op) {
  let activeRoute = getActiveRouteName(state),
    getEntity = id => ge(state, id),
    getYMMT = id => gymmt(state, id, false),
    rooftopName = getRooftopName(state),
    activeQuery = getActiveQuery(state),
    activeParams = getActiveParams(state),
    titleFunc = TITLES[activeRoute] || defaultTitle

  return {
    ...op,
    rooftopName,
    title: titleFunc({
      ...op,
      activeQuery,
      getEntity,
      getYMMT,
      rooftopName,
      activeParams,
    }),
  }
}

export default connect(
  mapStateToProps,
  { setPageTitle },
)(PageTitle)
